import { render } from "./FavoritesSkeletonLoader.vue?vue&type=template&id=616e21f8&scoped=true"
import script from "./FavoritesSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./FavoritesSkeletonLoader.vue?vue&type=script&lang=js"

import "./FavoritesSkeletonLoader.vue?vue&type=style&index=0&id=616e21f8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616e21f8"]])

export default __exports__